import React, {useState} from "react";
import {isEmpty} from "lodash";
import { Container, Row, Col } from "react-bootstrap";
import $ from "jquery";
import ContentModule from "../../modules/content_module";
import Contact_Form from "../forms/contact-form";

import "./FormComponent.scss";

const FormComponent = ({Module, GQLPage}) => {

    let menu_slug = GQLPage?.menu?.slug

    return (
        <React.Fragment>
            <section className={`form_section ${Module?.form_bg}`}>
                <Container>
                    <Row>
                        <Col>
                            <div className={`form-inner`} id={Module.id}>
                                {
                                    Module?.title_content &&
                                    <>
                                        <ContentModule Content={Module?.title_content} />
                                    </>
                                }

                                <div className="form_wrapper">
                                    <Contact_Form  to_email_id={Module?.to_email_id} menu_slug={menu_slug}  />
                                </div>


                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default FormComponent;